"use strict";
// Copyright (C) 2017-2026 Smart code 203358507
Object.defineProperty(exports, "__esModule", { value: true });
var toPath = function (link) { return link.startsWith('#') ? link.slice(1) : link; };
exports.default = toPath;
